import styled from 'styled-components';

interface IBlockProps {
  children: React.ReactNode;
  hasEllipsis: 'action'|'none';
}

const Block = styled('div')<IBlockProps>`
    text-overflow: ${props => props.hasEllipsis === 'action' ? 'ellipsis': 'inherit'};
    white-space: ${props => props.hasEllipsis === 'action' ? 'nowrap' : 'preWrap'};
    overflow: ${props => props.hasEllipsis === 'action' ? 'hidden' : 'auto'};
`

Block.defaultProps = {
  hasEllipsis: 'none'
}
export const TextBlock = ({children, ...rest}: IBlockProps) => {
  return <Block {...rest}>{children}</Block>;
}